import { Text } from '@belong/ui';
import GeneralIcon, { GENERAL_ICONS } from 'components/GeneralIcon/GeneralIcon';
import mutedIcon from './icon-execution-mode-muted.svg';
import { STRINGS } from './strings';
import type { CardLabel } from './types';

type Props = { label: CardLabel };

export function ExecutionModeCardLabel({ label }: Props) {
  if (!label) return null;

  if (label === 'discuss') {
    return (
      <div className="flex items-center gap-[6px]">
        <GeneralIcon icon={GENERAL_ICONS.ICON_FLAG} />
        <Text fontWeight="semibold">{STRINGS.card.discuss}</Text>
      </div>
    );
  }

  if (label === 'belongPro') {
    return (
      <Text fontWeight="semibold" className="text-green">
        {STRINGS.card.belongPro}
      </Text>
    );
  }

  return (
    <div className="flex items-center gap-[6px]">
      <img alt="" src={mutedIcon} className="h-[16px] w-[16px] shrink-0" />
      <Text fontWeight="semibold" className="text-dark-gray">
        {label === 'ownPro'
          ? STRINGS.card.ownPro
          : STRINGS.card.homeownerFixing}
      </Text>
    </div>
  );
}
